import { format } from "date-fns";

export interface Column {
  id: 'dataHoraSessao' | 'avaliadoEm' | 'crítica' | 'nota' | 'sessaoEscolhida' | 'virtual';
  label: string;
  minWidth?: number;
  maxWidth?: number;
  align?: 'right' | 'center' | 'left';
  format?: (value: any) => string;
}

export const labels: { [index: string]: string } = {
  1: 'Péssima',
  2: 'Ruim',
  3: 'Ok',
  4: 'Boa',
  5: 'Excelente',
};

export const columns: readonly Column[] = [
  { id: 'dataHoraSessao', label: 'Data e hora da sessão', minWidth: 100 , format: (value) => value ? format(new Date(value),"dd/MM/yyyy HH'h'mm"): ""},
  { id: 'sessaoEscolhida', label: 'Sessão escolhida', minWidth: 120, align: 'center'},
  { id: 'virtual', label: 'Tipo', minWidth: 100, maxWidth:100, align: 'center', format:(value)=> value === true ? "Virtual" : "Presencial"},
  { id: 'avaliadoEm', label: 'Avaliado em', minWidth: 150 , format: (value) => value ? format(new Date(value),"dd/MM/yyyy HH'h'mm"): ""},
  { id: 'crítica', label: 'Crítica', minWidth: 200, align: 'center'},
  { id: 'nota', label: 'Nota', minWidth: 100, maxWidth:100, align: 'center', format:(value)=> value ? labels[value]: ""},
];